
import PageContentContainer from "../../../Container/PageContentContainer";
import PaidTaskContainer from "../../../PaidTask/PaidTaskTable/PaidTaskContainer";

const ExternalsAcceptedPaidTasksPage = () => {
  return (
    <PageContentContainer>
      <PaidTaskContainer displayType={"assigneeView"} headline={"Angenommene Aufgaben"} />
    </PageContentContainer>
  );
};

export default ExternalsAcceptedPaidTasksPage;
